import { FeeDetailDTO } from "@models/platform-analysis/entities/steps/fee";
import { PDFFeeAnalysisConfig } from "@pages/platform-analysis/components/buttons/export-pdf/components/sections/fee-analysis/configs";
import { useStyles } from "@pages/platform-analysis/components/buttons/export-pdf/styles";
import { Text, View } from "@react-pdf/renderer";
import { calculateFeeDetailColumnWidth } from "../../../sections/fee-analysis/utils";
import { FeeAnalysisLabelConstants } from "@pages/platform-analysis/_id/steps/fee/analysis/constants";

interface PDFLabelLineDetailProps {
  firstProductFeeDetails: FeeDetailDTO[];
  hasTooManyFeeColumns: boolean;
  isExcludePerformanceFees?: boolean;
}

export const PDFLabelLineDetailV2 = ({
  firstProductFeeDetails,
  hasTooManyFeeColumns,
  isExcludePerformanceFees,
}: PDFLabelLineDetailProps) => {
  const { typographyStyle } = useStyles();
  const contentWidth = hasTooManyFeeColumns
    ? PDFFeeAnalysisConfig.FeeDetailContentWidthWithoutLogo
    : PDFFeeAnalysisConfig.FeeDetailContentWidth;

  const { pysColumnWidth, otherColumnWidth } = calculateFeeDetailColumnWidth(
    contentWidth,
    firstProductFeeDetails,
  );

  return (
    <View
      style={{
        flexDirection: "row",
        paddingLeft: 3,
        height: 25,
      }}
    >
      {firstProductFeeDetails.map((feeDetail, index) => {
        const width = feeDetail.isPysRefund ? pysColumnWidth : otherColumnWidth;
        return (
          <View
            key={index}
            style={{
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              width: width,
              height: PDFFeeAnalysisConfig.LabelLineDetailHeight,
              marginRight: index === 0 ? "5px" : 0,
              marginLeft:
                index === firstProductFeeDetails.length - 1 ? "5px" : 0,
            }}
          >
            <Text
              style={{
                ...typographyStyle?.body2,
                fontSize: 7,
                textAlign: "center",
              }}
            >
              {feeDetail.isSmaFees
                ? isExcludePerformanceFees
                  ? FeeAnalysisLabelConstants.SMAFeesExcPerfPDF
                  : FeeAnalysisLabelConstants.SMAFees
                : feeDetail.name}
            </Text>
          </View>
        );
      })}
    </View>
  );
};
